import { render, staticRenderFns } from "./clinical-training-event-participants-modal.vue?vue&type=template&id=600ecc29"
import script from "./clinical-training-event-participants-modal.vue?vue&type=script&lang=ts"
export * from "./clinical-training-event-participants-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports